import React from "react";

function PanelDatosPersonales({ datosPersonales, calendarioActivo, condicionesLaborales }) {
  var dni = '', nombres = '', apPaterno = '', apMaterno = '';
  datosPersonales.forEach(function(item) {
    if (item.descripcion === 'Dni') dni = item.nombre || '';
    if (item.descripcion === 'Nombres') nombres = item.nombre || '';
    if (item.descripcion === 'Ap. Paterno') apPaterno = item.nombre || '';
    if (item.descripcion === 'Ap. Materno') apMaterno = item.nombre || '';
  });

  var nombreCompleto = (nombres + ' ' + apPaterno + ' ' + apMaterno).trim();

  var vinculoTexto = '';
  var condiciones = (condicionesLaborales || []).filter(function(c) {
    return c.trabajador && c.trabajador.toString().trim() !== '';
  });
  if (calendarioActivo && calendarioActivo.observacion && condiciones.length > 0) {
    var tiposHabilitados = calendarioActivo.observacion.trim().split(',').map(function(t) { return t.trim(); });
    for (var i = 0; i < condiciones.length; i++) {
      if (condiciones[i].nombre) {
        var tipo = condiciones[i].nombre.split('-')[0].trim();
        if (tiposHabilitados.indexOf(tipo) >= 0) {
          if (tipo === 'DOA') vinculoTexto = 'DOCENTE NOMBRADO';
          else if (tipo === 'DOC') vinculoTexto = 'DOCENTE CONTRATADO';
          else vinculoTexto = tipo;
          break;
        }
      }
    }
  }

  return (
    <>
    <div style={{ background: '#fff', borderRadius: '16px', padding: '28px 20px', marginBottom: '16px', boxShadow: '0 4px 20px rgba(122,22,34,0.1)', border: '1px solid #f0e0e2' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: '70px', height: '70px', borderRadius: '50%', background: 'linear-gradient(135deg, #7A1622, #c0392b)', margin: '0 auto 14px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(122,22,34,0.3)' }}>
          <i className="fas fa-user-tie" style={{ color: '#fff', fontSize: '1.6rem' }}></i>
        </div>
        <div style={{ fontWeight: '700', fontSize: '1.05rem', color: '#2c3e50', letterSpacing: '0.3px' }}>{nombreCompleto || 'Cargando datos...'}</div>
        {vinculoTexto && (
          <div style={{ marginTop: '10px' }}>
            <span style={{ background: 'linear-gradient(135deg, #e8f5e9, #c8e6c9)', border: '1px solid #a5d6a7', borderRadius: '20px', padding: '5px 16px', fontSize: '0.76rem', fontWeight: '700', color: '#2E7D32', letterSpacing: '0.5px' }}>
              <i className="fas fa-briefcase" style={{ marginRight: '5px', fontSize: '0.7rem' }}></i>
              {vinculoTexto}
            </span>
          </div>
        )}
        {dni && (
          <div style={{ marginTop: '12px', background: '#f8f9fa', borderRadius: '8px', padding: '8px 14px', display: 'inline-block' }}>
            <span style={{ fontSize: '0.8rem', color: '#666' }}>DNI: </span>
            <span style={{ fontSize: '0.9rem', fontWeight: '700', color: '#333', letterSpacing: '1px' }}>{dni}</span>
          </div>
        )}
      </div>
    </div>

    {/* Instrucciones */}
    <div style={{ background: '#fff', borderRadius: '12px', padding: '16px 18px', border: '1px solid #e8e8e8', fontSize: '0.8rem', color: '#444' }}>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
        <span style={{ background: '#1565C0', color: '#fff', borderRadius: '50%', minWidth: '20px', height: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.68rem', fontWeight: '700', flexShrink: 0, marginTop: '2px' }}>1</span>
        <span style={{ lineHeight: '1.5' }}>Presione <strong style={{ color: '#1565C0' }}>"Ver Documento"</strong> para previsualizar su Declaracion Jurada con sus datos personales.</span>
      </div>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
        <span style={{ background: '#1565C0', color: '#fff', borderRadius: '50%', minWidth: '20px', height: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.68rem', fontWeight: '700', flexShrink: 0, marginTop: '2px' }}>2</span>
        <span style={{ lineHeight: '1.5' }}>Verifique que sus datos personales y condicion laboral sean correctos antes de firmar.</span>
      </div>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
        <span style={{ background: '#2E7D32', color: '#fff', borderRadius: '50%', minWidth: '20px', height: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.68rem', fontWeight: '700', flexShrink: 0, marginTop: '2px' }}>3</span>
        <span style={{ lineHeight: '1.5' }}>Presione <strong style={{ color: '#2E7D32' }}>"Firmar Documento"</strong>. El sistema aplica su firma digital certificada automaticamente.</span>
      </div>
      <div style={{ display: 'flex', gap: '10px' }}>
        <span style={{ background: '#6A1B9A', color: '#fff', borderRadius: '50%', minWidth: '20px', height: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.68rem', fontWeight: '700', flexShrink: 0, marginTop: '2px' }}>4</span>
        <span style={{ lineHeight: '1.5' }}>El documento firmado queda registrado automaticamente.</span>
      </div>
    </div>
    </>
  );
}

export default PanelDatosPersonales;
